var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VBreadcrumbs',{staticClass:"layout__default__navbar__breadcrumbs",attrs:{"items":_vm.breadcrumbs}})}
var staticRenderFns = []

export { render, staticRenderFns }